<template>
  <v-data-table
    :no-data-text="emptyTable"
    rows-per-page-text="Registros por página"
    item-key="id"
    :headers="headers"
    :items="items"
    v-model="items"
    :search="search"
    class="elevation-1"
    :hide-actions="!task_top"
    :hide-headers="!task_top"
    :rows-per-page-items="[25,50,100,{'text':'Todos','value':-1}]"
    :custom-filter="customizedFilter">
    <template slot="items" slot-scope="props">
      <tr>
        <td @click="props.expanded = !props.expanded" width='5%'>
          <v-btn :color="props.item.all_subtasks.length > 0 ? 'primary' : 'blue-grey'" :class="props.item.all_subtasks.length > 0 ? '' : 'white--text'" small fab>{{ props.item.all_subtasks.length }}</v-btn>
        </td>
        <td @click="props.expanded = !props.expanded" width='5%'>{{ props.item.identifier }}</td>
        <td @click="editSubItem(props.item['id'], items, 4)">
          <a class="task-text" >{{ props.item.id_text }}</a>
        </td>
        <td @click="props.expanded = !props.expanded" width='5%'>{{ (props.item.prevision || props.item.prevision === 0) ? props.item.prevision : '' }}</td>
        <td align="center" width="10%">
          <v-tooltip bottom>
            <v-btn icon slot="activator" class="mx-0">
              <v-icon color="grey darken-1">list</v-icon>
            </v-btn>
            <span>
              <p-other-field :othersFields="othersFields(props.item)"></p-other-field>
            </span>
          </v-tooltip>
          <v-menu
            left
            nudge-top="8"
            content-class="elevation-0 menu_content"
            transition="slide-x-reverse-transition"
            :offset-x="true"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn fab small v-on="on" slot="activator" icon class="mx-0">
                <v-icon medium>more_vert</v-icon>
              </v-btn>
            </template>
            <v-tooltip bottom>
              <v-btn slot="activator" small fab class="mx-0" @click="createSubItem(props.item, props.item.all_subtasks)" :disabled="!checkPermission(entity, 'create')">
                <v-icon color="primary">add</v-icon>
              </v-btn>
              <span>{{createTooltipText}} subtarefas.</span>
            </v-tooltip>
            <v-tooltip bottom>
              <v-btn slot="activator" small color="grey lighten-4" fab class="mx-0" @click="editSubItem(props.item['id'], items, 4)" :disabled="!checkPermission(entity, 'manage')">
                <v-icon color="teal">build</v-icon>
              </v-btn>
              <span>{{manageTooltipText}}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <v-btn slot="activator" small fab class="mx-0" @click="deleteSubItem(props.item, items)" :disabled="!checkPermission(entity, 'delete')">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
              <span>{{deleteTooltipText}}</span>
            </v-tooltip>
          </v-menu>
        </td>
      </tr>
    </template>
    <template slot="expand" slot-scope="props">
      <v-card>
        <v-card-text class="grey lighten-2">
          <p-tasktemplate-expand @createSubItem="createSubItem" @editSubItem="editSubItem" @deleteSubItem="deleteSubItem" :headers="headers" :itemFather="props.item" :items="props.item.all_subtasks" :task_top="false">
          </p-tasktemplate-expand>
        </v-card-text>
      </v-card>
    </template>
  </v-data-table>
</template>

<style>
  .speed-dial {
    display: inline !important;
  }
  .menu_content {
    padding: 0 10px 10px 10px;
  }
</style>

<script>
  import access from '../../mixin/access'
  import tooltip from '../../mixin/tooltip'
  import POtherField from './../shared/POtherField'

  export default {
    mixins: [access, tooltip],
    props: {
      items: {
        type: Array
      },
      itemFather: {
        type: Object
      },
      headers: {
        type: Array
      },
      task_top: {
        type: Boolean,
        default: true
      },
      search: {
        type: String,
        default: ''
      },
      dialog: {
        type: Boolean
      }
    },
    components: {POtherField},
    name: 'p-tasktemplate-expand',
    data () {
      return {
        entity: 'tasktemplates'
      }
    },
    methods: {
      createSubItem: function (item, items) {
        this.$emit('createSubItem', item, items)
      },
      editSubItem: function (tasktemplateId, items, view) {
        this.$emit('editSubItem', tasktemplateId, items, view)
      },
      deleteSubItem: function (item, items) {
        this.$emit('deleteSubItem', item, items)
      },
      updateDatetimeEnd: function (datetime) {
        this.editedItem.end = datetime
      },
      othersFields (item) {
        return [
          {field: this.translate('table.' + this.entity + '.field.user_id'), value: item.user ? item.user.id_text + (item.connection_company ? (' (' + item.connection_company.id_text + ')') : '') : item.level === 1 ? '' : 'Buscar da Tarefa Mãe'},
          {field: this.translate('table.' + this.entity + '.field.client_id'), value: item.client ? item.client.id_text : item.level === 1 ? '' : 'Buscar da Tarefa Mãe'},
          {field: this.translate('table.' + this.entity + '.field.team_id'), value: item.team ? item.team.id_text : item.level === 1 ? '' : 'Buscar da Tarefa Mãe'},
          {field: this.translate('table.' + this.entity + '.field.category_id'), value: item.category ? item.category.id_text : item.level === 1 ? '' : 'Buscar da Tarefa Mãe'},
          {field: this.translate('table.' + this.entity + '.field.urgency'), value: (item.urgency > 0) ? this.translate('value.task_urgency').filter(a => a.value === item.urgency)[0].text : item.level === 1 ? '' : 'Buscar da Tarefa Mãe'},
          {field: this.translate('table.' + this.entity + '.field.note '), value: item.note ? item.note : ''}
        ]
      },
      customizedFilter (items, search, filter) {
        search = search.toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        let fieldSearch = this.headers.map(function (val) {
          let reduce = val['value'].substring(0, val['value'].indexOf('.'))
          if (val['value'].indexOf('.') >= 0) {
            return [reduce, 2]
          } else {
            return [val['value'], 1]
          }
        })
        return items.filter(i => (
          fieldSearch.some(j => {
            if (j[1] === 1) {
              return i[j[0]] ? filter(i[j[0]].toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''), search) : false
            } else {
              return i[j[0]] ? filter(i[j[0]]['id_text'].toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''), search) : false
            }
          })
        ))
      }
    },
    computed: {
      emptyTable () {
        return 'Ainda não foram cadastrados registros de ' + this.translate('table.' + this.entity + '.title')[1]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/shared/PTasktemplateExpand.vue